import { Video } from '@vimeo/gctl-api/models/components/schemas/video/Video';

// Guard Page Template Values
export const REVEAL_HEIGHT_LARGE = 305; // 261.3, MODULES_GAP_LARGE + the rest and round up 2px
export const REVEAL_HEIGHT = 297; // 253.3; MODULES_GAP + the rest and round up 2px

export const SHOWCASE_REVEAL_HEIGHT_LARGE = 378; // REVEAL_HEIGHT + SHOWCASE_NAV_HEIGHT
export const SHOWCASE_REVEAL_HEIGHT = 370; // REVEAL_HEIGHT + SHOWCASE_NAV_HEIGHT

export const NAV_HEIGHT = 63;
export const SHOWCASE_NAV_HEIGHT = 73;

/**
 * Clip (view) privacy values
 * ref: frontend/libs/gctl-api/models/components/schemas/video/Video.ts
 * ref: https://github.com/vimeows/vimeo/blob/cef8a839fddaa362694179197dbf8ec43977de0d/objects/Clip.php#L352-L366
 */
export type VideoPrivacy = Video['privacy']['view'];
export type Privacy = Video['privacy'];

/** display text "Public" */
export const PRIVACY_PUBLIC: VideoPrivacy = 'anybody';

/** display text "Password" */
export const PRIVACY_PASSWORD: VideoPrivacy = 'password';

/** display text "Unlisted" */
export const PRIVACY_UNLISTED: VideoPrivacy = 'unlisted';

/** display text "Private" */
export const PRIVACY_NOBODY: VideoPrivacy = 'nobody';

/** display text "Hide from Vimeo" */
export const PRIVACY_DISABLE: VideoPrivacy = 'disable';

/** display text "People I follow", legacy privacy option, underlining Public privacy */
export const PRIVACY_FOLLOW: VideoPrivacy = 'contacts';

/** display text "People I choose", legacy privacy option, underlining Public privacy */
export const PRIVACY_USER: VideoPrivacy = 'users';
